import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { compose } from "redux";

import withTranslations from "../../../../../hocs/withTranslations";
import useInvoices from "../../../../../hooks/useInvoices";
import { createPaymentInvoicePromiseCreator } from "../../../../../redux/modules/paymentInvoices";
import InvoiceForm from "../../../landingPage/pages/Plans/components/InvoiceForms/components/InvoiceForm";
import Loader from "../../../common/Loader";
import NewModal from "../../NewModal";

const GenerateInvoiceModal = ({ translate, locale, hideModal, paymentId }) => {
  const dispatch = useDispatch();
  const invoiceFormRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const {
    savedInvoicesEnabled,
    fetchSavedInvoiceDataAsync,
    updateSavedInvoiceDataAsync
  } = useInvoices();

  const needsInvoiceData = !savedInvoicesEnabled;

  useEffect(() => {
    let cancelled = false;

    (async () => {
      setLoading(true);

      try {
        await fetchSavedInvoiceDataAsync({ silent: true });
      } catch (error) {
        console.error(error);
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [fetchSavedInvoiceDataAsync]);

  const handleAccept = async () => {
    if (submitting || loading) {
      return;
    }

    setSubmitting(true);

    try {
      if (needsInvoiceData) {
        const invoiceFormData = await invoiceFormRef.current?.submit();

        if (!invoiceFormData) {
          setSubmitting(false);
          return;
        }

        await updateSavedInvoiceDataAsync({
          invoiceFormData: {
            ...invoiceFormData,
            invoicesEnabled: true
          },
          skipSuccessAlert: true,
          silent: true
        });
      }

      await createPaymentInvoicePromiseCreator(
        { payment_id: paymentId },
        dispatch
      );
    } catch (error) {
      console.error(error);
    } finally {
      setSubmitting(false);
      hideModal?.();
    }
  };

  return (
    <NewModal
      hideModal={hideModal}
      title={translate("transaction_history_create_invoice_modal_title")}
      cancelButtonText={translate("Cancel")}
      acceptButtonText={translate(
        "transaction_history_create_invoice_modal_confirm"
      )}
      acceptButtonDisabled={loading || submitting}
      acceptButtonLoading={submitting}
      hideOnAccept={false}
      onAccept={handleAccept}
    >
      {loading ? (
        <Loader small />
      ) : (
        <>
          <p className="text-sm text-black opacity-70 mb-6">
            {translate("transaction_history_create_invoice_modal_message")}
          </p>
          {needsInvoiceData ? (
            <InvoiceForm
              translate={translate}
              locale={locale}
              ref={invoiceFormRef}
            />
          ) : null}
        </>
      )}
    </NewModal>
  );
};

export default compose(withTranslations)(GenerateInvoiceModal);
